const axios = require("axios");
import i18n from "@/i18n";

axios.defaults.baseURL = process.env.VUE_APP_BASEAPI;
// axios.interceptors.request.use(function(config) {
//   config.headers.Authorization = localStorage.getItem("Token") || "";
//   return config;
// });
const state = {};
const getters = {};
const mutations = {};
const actions = {
  forgotpassword({ commit, dispatch }, userData) {
    return new Promise((resolve, reject) => {
      axios
        .post("/forgotpassword", userData)
        .then((resp) => {
          if (resp && resp.data && resp.data.Transfer) {
            switch (resp.data.Transfer) {
              case "200":
                resolve("Password link sent");
                break;
              default:
                reject(`Unknown errorcode ${resp.data.Transfer}`);
            }
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  validateforgotpasswordtoken({ commit, dispatch }, userData) {
    return new Promise((resolve, reject) => {
      console.log(userData);
      axios
        .post("/validateforgotpasswordtoken", userData)
        .then((resp) => {
          console.log(resp);
          if (resp && resp.data && resp.data.Transfer) {
            switch (resp.data.Transfer) {
              case "200":
                resolve(resp.data.token);
                // console.log(resp.data);
                break;
              default:
                reject(`Unknown errorcode ${resp.data.Transfer}`);
            }
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  setnewpassword({ commit, dispatch }, userData) {
    return new Promise((resolve, reject) => {
      axios
        .post("/setnewpassword", userData)
        .then((resp) => {
          if (resp && resp.data && resp.data.Transfer) {
            switch (resp.data.Transfer) {
              case "200":
                resolve("ok");
                // console.log(resp.data);
                break;
              default:
                reject(`Unknown errorcode ${resp.data.Transfer}`);
            }
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
